import Richtext from "./Richtext";

export default Richtext;
